import styles from './Activation.module.css'
import { useForm, SubmitHandler } from 'react-hook-form'
import { Link, useNavigate } from 'react-router-dom'
import mixpanel from 'mixpanel-browser'

import CodeInput from '../../../common/components/Auth/ActivationCodeInput'
import { ActivationCode } from '../../../types/ActivationCode'
import globalStyles from '../../../styles/confirmation.module.css'
import Button from '../../../common/components/Button'
import AuthBase from '../../../common/components/Auth/AuthBase'
import { t } from 'i18next'

const ActivationPage = () => {
  const navigate = useNavigate()
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm<ActivationCode>()

  const onSubmit: SubmitHandler<ActivationCode> = async (data) => {
    const response = await fetch(
      `${process.env.REACT_APP_API_URL}/auth/confirm`,
      {
        method: 'POST',
        headers: new Headers({
          'Content-Type': 'application/json; charset=utf-8',
        }),
        body: JSON.stringify({
          email: localStorage.getItem('email'),
          code: data.code,
        }),
      },
    )

    if (response.ok) {
      mixpanel.track('Account Confirmed')
      navigate('/confirmation')
    }
  }

  return (
    <AuthBase hasBackButton>
      <p className={globalStyles.formLabel}>{t('signup.title')}</p>
      <p className={styles.header}>{t('signup.header')}</p>
      <form
        onSubmit={handleSubmit(onSubmit)}
        className={globalStyles.formContainer}
      >
        <CodeInput register={register} errors={errors} />
        <div>
          <Button title={t('signup.getAccess')} />
        </div>
      </form>
      <div className={styles.haveAccountSign}>
        <p>{t('signup.alreadyHaveAccount')}</p>
        <Link to="/">
          <p className={styles.login}>{t('login.logIn')}</p>
        </Link>
      </div>
    </AuthBase>
  )
}

export default ActivationPage
